import React, { useEffect, useState } from 'react'
import NavBar from '../Component/NavBarFooter/NavBar'
import Banner from '../Component/JoblistingPage/Banner'
import JobLisit from '../Component/JoblistingPage/JobLisit'
import CVReviewSection from '../Component/HomePage/CVReviewSection'
import Footer from '../Component/NavBarFooter/Footer'
import { useAuth } from '../Context/ContextProvider'
import { useLocation } from 'react-router-dom'

function JoblistingPage() {
  const {getJobs,parseQueryParams}=useAuth()
 const [jobList, setJoblist] = useState([])
 const [filterData, setFilterData] = useState({
  keyword: "",
  city_code: "",
  job_category_id: "",
 })
 const [pagination, setPagination] = useState(null)
 const location = useLocation()

    useEffect(()=>{
        const fetchJobs=async ()=>{
          try {
            const parsed = parseQueryParams(location.search);
            setFilterData(parsed);
        const jobResult = await getJobs(parsed);
        setJoblist(jobResult?.data?.jobsList);
        setPagination(jobResult?.data?.pagination);
            
      } catch (error) {
        console.error("An error occurred while fetching data:", error);
      }
        }
        fetchJobs()
    },[location.search])
  return (
    <div>
        <NavBar/>
        <Banner filterData={filterData} setFilterData={setFilterData}/>
        <JobLisit jobList={jobList} pagination={pagination}/>
        <CVReviewSection/>
        <Footer/>
    </div>
  )
}

export default JoblistingPage